export default __webpack_public_path__ + "static/media/eth-logo.45e11d29.svg";